<template>
<el-container>
      <el-form ref="form" :model="form" label-width="250px">


        <el-form-item label="资产名称">
          <el-input v-model="form.propertyName"></el-input>
        </el-form-item>


        <el-form-item label="资产规格">
          <el-input v-model="form.propertySpecification"></el-input>
        </el-form-item>



      <el-form-item label="资产的RFID标签">
        <el-input v-model="form.propertyRfid"></el-input>
      </el-form-item>

      <!-- 需要Tree来渲染 -->
      <el-form-item label="资产状态">
        <el-select v-model="form.propertyState" placeholder="是否为资产状态">
          <el-option label="闲置" :value='1'></el-option>
          <el-option label="使用中" :value='2'></el-option>
          <el-option label="审批中" :value='3'></el-option>
          <el-option label="报废" :value='4'></el-option>
        </el-select>
      </el-form-item>


      <!-- 单位人员树 -->
      <el-form-item label="管理员部门人">

        <el-input v-model="form.managerName" :value="ManagerUser">
          <!-- <el-input v-model="form.propertyTypeId" :value="id"> -->
            <el-button
              size="mini"
               style="padding-right:10px"
               slot="suffix"
               type="text"
              @click="dialogManager = true">选择</el-button> </el-input>
              <el-dialog title="选择管理员部门人员"
              append-to-body
              :visible.sync="dialogManager" width="25%">

              <el-input
                placeholder="输入关键字进行过滤"
                v-model="filterText">
              </el-input>
                <el-tree
                  class ="TreeBlock"
                  :data="MangerData"
                  :filter-node-method="filterNode"
                  node-key="id"
                  @node-click="TreeMangerClick"
                  ref="tree"
                  :props="defaultProps"
                  default-expand-all:false
                  :expand-on-click-node="false">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ node.label }}</span>
                  </span>
                </el-tree>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="dialogManager = false">取 消</el-button>
                  <el-button type="primary" @click="dialogManager = false;">确 定</el-button>
                </div>
              </el-dialog>

      </el-form-item>

      <!-- 单位人员树 -->
      <el-form-item label="使用者">
         <el-input v-model="form.usedName" :value="User">
                     <el-button
                       size="mini"
                        style="padding-right:10px"
                        slot="suffix"
                        type="text"
                       @click="dialogUser = true">选择</el-button> </el-input>
                       <el-dialog title="请选择使用者"
                       append-to-body
                       :visible.sync="dialogUser" width="25%">
                       <el-input
                         placeholder="输入关键字进行过滤"
                         v-model="filterText">
                       </el-input>

                         <el-tree
                           class ="TreeBlock"
                           :data="UserData"
                           :filter-node-method="filterNode"
                           node-key="id"
                           @node-click="TreeUserClick"
                           ref="tree"
                           :props="defaultProps"
                           default-expand-all:false
                           :expand-on-click-node="false">
                           <span class="custom-tree-node" slot-scope="{ node, data }">
                             <span>{{ node.label }}</span>
                           </span>
                         </el-tree>
                         <div slot="footer" class="dialog-footer">
                           <el-button @click="dialogUser = false">取 消</el-button>
                           <el-button type="primary" @click="dialogUser = false;">确 定</el-button>
                         </div>
                       </el-dialog>
      </el-form-item>


      <el-form-item label="管理部门">
         <el-select
         v-model="form.managerDeptName"
          :value="VmanagerDeptId"
          placeholder="请选择管理部门">
          <el-option
          v-for="i in DName"
          :key="i.departmentName"
          :label="i.departmentName"
          :value="i.departmentId">
          </el-option>
         </el-select>



      </el-form-item>


      <el-form-item label="使用部门">
        <el-select
        v-model="form.usedDeptName"
        :value="VownerDeptId"

        placeholder="请选择使用部门">
         <el-option
         v-for="i in DName"
         :key="i.departmentId"
         :label="i.departmentName"
         :value="i.departmentId">
         </el-option>
        </el-select>
      </el-form-item>


        <el-form-item label="资产固定编码">
          <el-input v-model="form.propertyCode" placeholder="输入资产固定编码"></el-input>
        </el-form-item>


        <el-form-item label="资产类别">
          <el-input v-model="form.propertyType" :value="id">
            <!-- <el-input v-model="form.propertyTypeId" :value="id"> -->

              <el-button
                size="mini"
                 style="padding-right:10px"
                 slot="suffix"
                 type="text"
                @click="dialogPropertyTypeId = true">选择</el-button> </el-input>
                <el-dialog title="选择资产类别"
                append-to-body
                :visible.sync="dialogPropertyTypeId" width="25%">

                <el-input
                  placeholder="输入关键字进行过滤"
                  v-model="filterText">
                </el-input>
                  <el-tree
                    class ="TreeBlock"
                    :data="data"
                    :filter-node-method="filterNode"
                    node-key="id"
                    @node-click="TreePropertyClick"
                    ref="tree"
                    :props="defaultProps"
                    default-expand-all:false
                    :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>

                    </span>
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogPropertyTypeId = false">取 消</el-button>
                    <el-button type="primary" @click="dialogPropertyTypeId = false;">确 定</el-button>
                  </div>
                </el-dialog>

        </el-form-item>

        <el-form-item label="存放区域">
          <el-input v-model="form.holdPlace" :value="PlaceId">
              <el-button
                size="mini"
                 style="padding-right:10px"
                 slot="suffix"
                 type="text"
                @click="dialogPlace = true">选择</el-button> </el-input>
                <el-dialog title="选择存放区域"
                append-to-body
                :visible.sync="dialogPlace" width="25%">
                  <el-input
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
                  </el-input>
                  <el-tree
                    class ="TreeBlock"
                    :data="PlaceData"
                    :filter-node-method="filterNode"
                    node-key="id"
                    @node-click="TreePlaceClick"
                    ref="tree"
                    :props="defaultProps"
                    default-expand-all:false
                    :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>

                    </span>
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogPlace = false">取 消</el-button>
                    <el-button type="primary" @click="dialogPlace = false;">确 定</el-button>
                  </div>
                </el-dialog>


        </el-form-item>


        <el-form-item label="单位编号">
          <el-select v-model="form.unitName" placeholder="请选择使用部门">
           <el-option
           v-for="i in DUnit"
           :key="i.unitId"
           :value="i.unitId">
           {{i.unitName}}
           </el-option>
          </el-select>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="onSubmit">立即修改</el-button>
        </el-form-item>
      </el-form>


      </el-container>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'Property_Edit',
     data () {
       const data = [{
               id: 1,
               label: '一级 1',
               children: [{
                 id: 4,
                 label: '二级 1-1',
                 children: [{
                   id: 9,
                   label: '三级 1-1-1'
                 }, {
                   id: 10,
                   label: '三级 1-1-2'
                 }]
               }]
             }];


        const PlaceData = [{
                id: 1,
                label: '一级 1',
                children: [{
                  id: 4,
                  label: '二级 1-1',
                  children: [{
                    id: 9,
                    label: '三级 1-1-1'
                  }, {
                    id: 10,
                    label: '三级 1-1-2'
                  }]
                }]
              }];
       return {
        filterText: '',
        id:'',
        PlaceId:'',
        User:'',

        VownerDeptId:'',
        VmanagerDeptId:'',


        ManagerUser:'',
          defaultProps: {
                   children: 'children',
                   label: 'label'
                 },
         data: JSON.parse(JSON.stringify(data)),
         PlaceData: JSON.parse(JSON.stringify(PlaceData)),
         MangerData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],
         UserData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],
         defaultProps: {
                  children: 'children',
                  label: 'label'
                },
         dialogUser:false,
         dialogPropertyTypeId:false,
         dialogManager:false,
         dialogPlace:false,
         DName:[{
           departmentId:'',
           departmentName:'',
         }],
         DUnit:[{
           unitName:'',
           unitId:'',
         }],
            form: {
                    createDate:'',
                    epc:'',
                    supplier:'',
                     del:'',
                     holdPlace:'',
                     managerDeptId:'',
                     managerDeptName:'',
                     managerId:'',
                     managerName:'',
                     mgrName:'',
                     outProperty:'',
                     ownerDeptId:'',
                     ownerId:'',
                     placeId:'',
                     propertyCode:'',
                     propertyId:'',
                     propertyModel:'',
                     propertyName:'',
                     propertyRfid:'',
                     propertySpecification:'',
                     propertyState:'',
                     propertyType:'',
                     propertyTypeId:'',
                     unitId:'',
                     unitName:'',
                     usedDeptName:'',
                     updateDate:'',
                     usedName:'',
                  }
        };
     },
     mounted:function() {
		// 首先是当页面加载的时候自动渲染这些数据
		
		// 表格里面的数据
       this.showData();
	   // 查询条件里面的数据预加载    区域信息
       this.showPlaceData();
	    // 查询条件里面的数据预加载    部门信息
       this.showDepartmentData();
	   // 查询条件里面的数据预加载    单位信息
       this.showUnitData();
	   // 查询条件里面的数据预加载    人员信息
       this.showMData();

     },


     watch: {
			// 树状结构的显示核心
           filterText(val) {
             this.$refs.tree.filter(val);
           }
         },
     methods: {
	  // 主页编辑按钮点击传过来的参数
      showIndexData(val){
        this.form = val
      },


	// 获取类别信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是类别信息ID
    TreePropertyClick(data){
          this.id = data.id
          this.form.propertyType = data.label
    },
	// 获取区域信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是区域ID
      TreePlaceClick(data){
          this.PlaceId = data.id
          this.form.holdPlace = data.label
      },
	  // 获取管理人信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是管理人ID
      TreeMangerClick(data){
          this.ManagerUser = data.realId
          this.form.managerName = data.label

      },

	  // 获取使用人信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是使用人ID
      TreeUserClick(data){
          this.User = data.realId
          this.form.usedName = data.label
      },



      filterNode(value, data) {
              if (!value) return true;
              return data.label.indexOf(value) !== -1;
            },




		// 将所有from的数据上传提交修改
        onSubmit() {
          this.form.placeId = this.PlaceId
          this.form.propertyTypeId = this.id
          this.form.ownerId = this.User
          this.form.outProperty = parseInt(this.form.outProperty)
          this.form.propertyState = parseInt(this.form.propertyState)
          this.form.managerId = this.ManagerUser
          var params = this.form
          var authorization = Cookies.get("Authorization");

           this.axios({
               method: 'POST',
               url: '/property/updateProperty',
               data:params,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
               this.open2('修改成功')
			   // 重新刷新Property_Index里的数据
              this.$parent.$parent.$parent.$parent.$parent.showData()
              this.$parent.$parent.$parent.$parent.$parent.dialogFormEdit = false

             })
        },
		// 功能成功传来的数据
        open2(val) {
                this.$message({
                  message: val,
                  type: 'success'
                });
              },


		// 请求小杜接口/public/getCanHandleDepartmentList获取部门信息然后将数据传给DName在149行使用
        showDepartmentData(){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: 1,
           pageSize: 5,
         }
          this.axios({
              method: 'GET',
              url: '/public/getCanHandleDepartmentList',
              params:params,
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
             this.DName = resp.data.data;
            })
        },


		// 请求小杜接口public/getTree获取区域信息然后将数据传给PlaceData在221行
        showPlaceData(){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: 1,
           pageSize: 5,
         }
          this.axios({
              method: 'GET',
              url: '/public/getTree',

              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
             this.PlaceData=resp.data.data;
            })
        },





		  // 请求小杜接口public/getTree获取区域信息然后将数据传给MangerData和UserData分别在65行和114行
          showMData(){
           var authorization = Cookies.get("Authorization");
            this.axios({
                method: 'GET',
                url: '/public/getUnitTree',
                header:{
                 'Authorization':authorization,
                	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                	}
              }).then((resp)=>{
               // var arr = new Array(resp.data.data) ;
               this.MangerData=resp.data.data;
               this.UserData = resp.data.data;
              })
          },



	
		  // 主要数据展示给tableData
          showData(){
           var authorization = Cookies.get("Authorization");

            this.axios({
                method: 'GET',
                url: '/public/getPropertySortTree',
                header:{
                 'Authorization':authorization,
                	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                	}
              }).then((resp)=>{
               this.data=resp.data.data;
              })
          },


		// 请求小杜接口/public/getCanWatchUnit获取单位信息然后将数据传给DUnit在247行
        showUnitData(){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: 1,
           pageSize: 5,
         }
          this.axios({
              method: 'GET',
              url: '/public/getCanWatchUnit',
              params:params,
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
             this.DUnit = resp.data.data;

            })
        },





     }
   }
</script>

<style>
  .Tree{
    width: 75%;
    border-style: solid;
    /* margin-top: 2%; */
    border-width: 3px;
    border-radius: 20px;
    border-color: #33CCFF;
  }
  .TreeBlock{
    margin-top: 1.5%;
    margin-left: 1%;
    margin-right: 1%;
    margin-bottom: 1%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Property/Property_Edit.vue